import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import AccountScreen from "../screens/AccountScreen";
//import MessagesScreen from "../screens/MessagesScreen";
import UserFixoScreen from "../screens/UserFixoScreen";
import ListingsScreen from "../screens/ListingsScreen";
import ListingDetailsScreen from "../screens/ListingDetailsScreen";
//import ProfileEditScreen from "../screens/ProfileEditScreen";
import FoundUserScreen from "../screens/FoundUserScreen";
import FollowersScreen from "../screens/FollowersScreen";
import FollowedScreen from "../screens/FollowedScreen";
//import ListingEditScreen from "../screens/ListingEditScreen";
//import ListingSelectSeedOrPubtionScreen from "../screens/ListingSelectSeedOrPubtionScreen";
import ListingsSeedsScreen from "../screens/ListingsSeedsScreen";
import ListingDetailsSeedScreen from "../screens/ListingDetailsSeedScreen";
import PickerActionsScreen from "../screens/PickerActionsScreen";
import ActionScreen from "../screens/ActionScreen";
//import CommentsSeedScreen from "../screens/CommentsSeedScreen";
//import AddSeedScreen from "../screens/AddSeedScreen";
//import ChatUserListScreen from "../screens/ChatUserListScreen";
//import ChatScreen from "../screens/ChatScreen";
import ActionComponentScreen from "../screens/ActionComponentScreen";
//import CardOriginComponent from "../components/CardOriginComponent";
import ActionEditScreen from "../screens/ActionEditScreen";

const Stack = createStackNavigator();

const AccountNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="Account" component={UserFixoScreen} />
    {/* <Stack.Screen name="Messages" component={MessagesScreen} /> */}
    {/* <Stack.Screen name="ProfileEdit" component={ProfileEditScreen} /> */}
    <Stack.Screen name="Listings Seed" component={ListingsSeedsScreen} />
    <Stack.Screen name="Seed Details" component={ListingDetailsSeedScreen} />
    <Stack.Screen name="Editing" component={ActionEditScreen} />
    <Stack.Screen name="Working on" component={ActionComponentScreen} />
    <Stack.Screen name="Editar perfil" component={AccountScreen} />


    <Stack.Screen name="Listing" component={ListingsScreen} />
    <Stack.Screen name="ListingDetails" component={ListingDetailsScreen} />
    <Stack.Screen name="Action List" component={PickerActionsScreen} />
    <Stack.Screen name="AddAction" component={ActionScreen} />
    {/* <Stack.Screen name="Comments Seeds" component={CommentsSeedScreen} /> */}
    {/* <Stack.Screen name="Chat List" component={ChatUserListScreen} />
    <Stack.Screen name="Chat" component={ChatScreen} /> */}




    <Stack.Screen name="FoundUser" component={FoundUserScreen} />
    <Stack.Screen name="Followers" component={FollowersScreen} />
    <Stack.Screen name="Followed" component={FollowedScreen} />


  </Stack.Navigator>
);

export default AccountNavigator;
